<template lang="pug">
v-chip.g-chip(v-bind="{ ...$attrs, label, close, closeIcon }" v-on="$listeners")
  slot
</template>

<script>
export default {
  name: 'GChip',
  props: {
    label: {
      type: Boolean,
      default: true,
    },
    close: {
      type: Boolean,
      default: true,
    },
    closeIcon: {
      type: String,
      default: 'mdi-close',
    },
  },
  data: () => ({}),
  computed: {},
};
</script>

<style lang="scss" scoped>
@import "Chip.scss";
</style>
